import { getPageLanguage } from '../../utils/get-page-language.mjs';
import configuration from '../../configuration.mjs';

const COLUMN_KEYS = ['itemNumber', 'livingAreaValue', 'numberOfRoomsValue', 'monthlyFeeValue', 'priceValue', 'status', false];
const DEFAULT_SORT_KEY = 'status';

/**
 * @param {Element} tableBody
 * @param {Array<{itemNumber: string, livingArea: string, livingAreaValue: number|null, numberOfRooms: string, numberOfRoomsValue: number|null, monthlyFee: string, monthlyFeeValue: number|null, price: string, priceValue: number|null, status: string, url: string, linkText: string}>} items
 * @returns {void}
 */
function renderRows(tableBody, items) {
  tableBody.innerHTML = items.map(item => {
    const linkCell = (item.url && item.linkText)
      ? `<td><a href="${item.url}">${item.linkText}</a></td>`
      : '<td></td>';

    return `<tr>
      <td>${item.itemNumber || ''}</td>
      <td>${item.livingArea || ''}</td>
      <td>${item.numberOfRooms || ''}</td>
      <td>${item.monthlyFee || ''}</td>
      <td>${item.price || ''}</td>
      <td>${item.status || ''}</td>
      ${linkCell}
    </tr>`;
  }).join('');
}

/**
 * @param {Element} rootElement
 */
export default async (rootElement = document.body) => {
  const projectEstatesContainer = rootElement.querySelector('#project-estates-container');
  if(!projectEstatesContainer) {
    return;
  }

  const showAllProjectEstatesButton = projectEstatesContainer.querySelector('.show-all-estates-button');
  if(!!showAllProjectEstatesButton) {
    showAllProjectEstatesButton.addEventListener('click', () => {
      projectEstatesContainer.classList.add('show-all-estates');
    });
  }

  const culture = getPageLanguage();
  const estateShortId = configuration.estate.shortId;

  const url = `/api/${culture}/estate/${estateShortId}/project-estates`;
  const response = await fetch(url);
  const items = await response.json();

  const table = projectEstatesContainer.querySelector('table');
  const tableBody = table.querySelector('tbody');

  renderRows(tableBody, items);

  if(items.length > 5) {
    showAllProjectEstatesButton.classList.add('show');
  }

  let sortKey = DEFAULT_SORT_KEY;
  let sortAsc = false;

  const headers = table.querySelectorAll('thead th');

  headers.forEach((th, index) => {
    const key = COLUMN_KEYS[index];
    if(!key) return;

    th.classList.add('sortable');
    th.style.cursor = 'pointer';

    if(key === DEFAULT_SORT_KEY) {
      th.setAttribute('data-sort', 'desc');
    }

    th.addEventListener('click', () => {
      if(sortKey === key) {
        sortAsc = !sortAsc;
      } else {
        sortKey = key;
        sortAsc = true;
      }

      headers.forEach(h => h.removeAttribute('data-sort'));
      th.setAttribute('data-sort', sortAsc ? 'asc' : 'desc');

      items.sort((a, b) => {
        const aVal = a[key];
        const bVal = b[key];

        if(aVal === null && bVal === null) return 0;
        if(aVal === null) return 1;
        if(bVal === null) return -1;

        if(aVal < bVal) return sortAsc ? -1 : 1;
        if(aVal > bVal) return sortAsc ? 1 : -1;
        return 0;
      });

      renderRows(tableBody, items);
    });
  });
};
